import styled from "styled-components";

export const Container = styled.div`
  color: #18182d;
  background-color: #18182d;
  width: 100%;
  min-height: fill-available;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  bottom: 0;
`;

export const Logo = styled.img`
  width: 12rem;
  margin: 1rem 0;
`;

export const MainContentContainer = styled.div`
  background-color: white;
  padding: 3rem 3rem 2rem 3rem;
  max-width: 30rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h4 {
    font-weight: 400;
  }

  a {
    color: #6f6f6f;
    margin-top: 5rem;
    text-decoration: none;

    &:hover {
      color: #18182d;
      text-decoration: underline;
    }
  }
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 3rem;

  a {
    margin-top: 1rem;
  }
`;
